// src/context/AuthContext.jsx
import React, { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

// Create the context
const AuthContext = createContext();

// Create the provider component
export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("company");
        navigate("/login");
    };

    // The value prop makes the handleLogout function available to any child component
    return (
        <AuthContext.Provider value={{ handleLogout }}>
            {children}
        </AuthContext.Provider>
    );
};

// Create a custom hook to easily use the context's value
export const useAuth = () => {
    return useContext(AuthContext);
};